import { render, staticRenderFns } from "./DetailBanner.vue?vue&type=template&id=704eae78&scoped=true&"
import script from "./DetailBanner.vue?vue&type=script&lang=js&"
export * from "./DetailBanner.vue?vue&type=script&lang=js&"
import style0 from "./DetailBanner.vue?vue&type=style&index=0&id=704eae78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704eae78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
